import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { CUSTOMER_PORTAL_CONFIG } from '@asset-solutions/customer-portal/config';
import {
  BaseServerLogger,
  LoggerConfig,
  type LoggerMetadata,
  type ServerRequestProperties
} from '@asset-solutions/shared/logging';

@Injectable()
export class CustomerPortalServerLogger extends BaseServerLogger {
  private readonly config = inject(CUSTOMER_PORTAL_CONFIG);

  public override shouldCallServer(config: LoggerConfig, metadata: LoggerMetadata): boolean {
    let httpError: HttpErrorResponse | undefined;
    if (metadata.message instanceof HttpErrorResponse) {
      httpError = metadata.message;
    } else {
      httpError = metadata.additional?.find((add) => add instanceof HttpErrorResponse);
    }

    // HTTP error status codes that we don't need to log, 404 and 0
    if (httpError && (httpError.status === 404 || httpError.status === 0)) {
      return false;
    }

    return config.logToServer;
  }

  public override getRequestProperties(): ServerRequestProperties {
    return { url: `${this.config.api.url}/log`, responseType: 'text' };
  }
}
